import React from "react";
import "./OurTeam.css";

const OurTeam = () => {
  return (
    <section className="OurTeam">
      <div className="container">
        <div className="OurTeam-subdiv">
          <div className="row">
            <div className="col-md-12">
              <div className="main-content">
                <div className="text-holder">
                  <div>
                    <h1 className="heading">Our Team</h1>
                    <div className="description">
                      <label>
                        Behind every successful campaign is a team of passionate
                        and creative professionals who work tirelessly to bring
                        your vision to life. At ReachOut Media Tech, we combine
                        years of industry experience with fresh,
                        forward-thinking ideas to deliver advertising solutions
                        that make an impact. From marketers and graphic
                        designers to content strategists and data analysts, our
                        team is dedicated to helping you achieve your business
                        goals.
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurTeam;
